import React from "react";
import ControllerTraw from "./components/ControllerTraw";
import "./printcontroller.scss";
function PrintController({item,api,action}:any) {
  const initialStateArray = Object.values(item);

  return (
   <div className="print_table">
     <table className="printcontroller">
      <thead>
        <tr>
          <th>name</th>
          <th>action</th>
          <th>position</th>
          <th>Size</th>
          <th>is show</th>
        </tr>
      </thead>
      <tbody>
        {initialStateArray?.map((item: any, index: number) => (
          <ControllerTraw target={item} key={index} api={api} action={action} />
        ))}
      </tbody>
    </table>
   </div>
  );
}

export default PrintController;
